import { getLanguageKeys } from './getLanguageKeys';

export const DEFAULT_SMART_RESOURCE_CONFIG = {
  lang: getLanguageKeys(),
};
